import { normalizeFields } from "@/forms/helpers";

export const model = normalizeFields({
  code: {
    type: "text",
    label: "Wprowadź kod",
    value: "",
    required: true,
  },
});
